var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#F6F8FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 48.2976C24.75 46.8749 25.5056 45.5593 26.7345 44.8425L37.2423 38.713C38.5756 37.9352 40.25 38.8969 40.25 40.4405V69.8334C40.25 70.938 39.3546 71.8334 38.25 71.8334H28.75C26.5409 71.8334 24.75 70.0426 24.75 67.8334V48.2976Z",
    fill: "#CDD2DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.25 50C71.25 47.7909 69.4591 46 67.25 46H57.75C56.6454 46 55.75 46.8954 55.75 48V69.8333C55.75 70.9379 56.6454 71.8333 57.75 71.8333H67.25C69.4591 71.8333 71.25 70.0425 71.25 67.8333V50Z",
    fill: "#CDD2DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 23C52 21.8954 51.1046 21 50 21H46C44.8954 21 44 21.8954 44 23V28C44 29.1046 44.8954 30 46 30H50C51.1046 30 52 29.1046 52 28V23Z",
    fill: "#CDD2DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3746 25.334H55.625C57.8341 25.334 59.625 27.1248 59.625 29.334V40.1258C59.625 41.2304 58.7296 42.1258 57.625 42.1258H53.875C52.7704 42.1258 51.875 43.0212 51.875 44.1258V69.834C51.875 70.9386 50.9796 71.834 49.875 71.834H46.1246C45.02 71.834 44.1246 70.9386 44.1246 69.834V36.3758C44.1246 35.2712 43.2292 34.3758 42.1246 34.3758H38.3746C37.27 34.3758 36.3746 33.4804 36.3746 32.3758V29.334C36.3746 27.1248 38.1654 25.334 40.3746 25.334Z",
    fill: "#CDD2DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountRound);
export default __webpack_public_path__ + "static/media/accountRound.b9c06f4a5c1213a81785a5e3c31d6782.svg";
export { ForwardRef as ReactComponent };